var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-processo", attrs: { shadow: "hover" } },
    [
      _c(
        "h1",
        [
          _vm._v("Retificar em massa"),
          _c(
            "el-row",
            { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "col-principal", attrs: { span: 10 } },
                [
                  _c("app-label", {
                    attrs: { label: "Adicione processo(s) e um título:" }
                  }),
                  _c(
                    "div",
                    { staticClass: "titulo-addPro" },
                    [
                      _c("el-input", {
                        staticClass: "add input-with-select",
                        attrs: { placeholder: "Titulo" },
                        model: {
                          value: _vm.titulo,
                          callback: function($$v) {
                            _vm.titulo = $$v
                          },
                          expression: "titulo"
                        }
                      }),
                      _c(
                        "el-input",
                        {
                          staticClass: "add input-with-select",
                          attrs: { placeholder: "N° do Processo" },
                          model: {
                            value: _vm.numProcesso,
                            callback: function($$v) {
                              _vm.numProcesso = $$v
                            },
                            expression: "numProcesso"
                          }
                        },
                        [
                          _c("el-button", {
                            staticClass: "color-default",
                            attrs: {
                              slot: "append",
                              icon: "el-icon-plus",
                              id: "botao-add"
                            },
                            on: { click: _vm.add },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
            [
              _c(
                "div",
                { staticClass: "caixa-processos" },
                _vm._l(_vm.processosDigitados, function(dadoProcesso) {
                  return _c(
                    "div",
                    { key: dadoProcesso.id, staticClass: "processoDigitado" },
                    [
                      _c(
                        "div",
                        [
                          _c("p", [
                            _vm._v(
                              "Numero processo: " +
                                _vm._s(dadoProcesso.numeroProcesso)
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              "Nome do Interressado: " +
                                _vm._s(dadoProcesso.nomeRazaoSocialInteressado)
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              "Nome do Usuario: " +
                                _vm._s(
                                  dadoProcesso.usuario.pessoa.nomeRazaoSocial
                                )
                            )
                          ]),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.deletar(dadoProcesso.id)
                                }
                              }
                            },
                            [_vm._v("deletar")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ]
          ),
          _c(
            "el-row",
            { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "col-principal", attrs: { span: 10 } },
                [
                  _c("app-label", { attrs: { label: "Motivo da mudança:" } }),
                  _c("app-editor-texto", {
                    ref: "editorTexto",
                    staticClass: "input",
                    on: { onTextChange: _vm.onTextChange },
                    model: {
                      value: _vm.mensagem,
                      callback: function($$v) {
                        _vm.mensagem = $$v
                      },
                      expression: "mensagem"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "retificarEmMassa" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.retificar }
                        },
                        [_vm._v("retificar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a74a0d6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a74a0d6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/RetificarEmMassa.vue
// module id = null
// module chunks = 